<app-cerrix-slide-out [isOpen]="isOpen" (isOpenChange)="close()">
    <div class="sidebar">
        <div class="sidebar-title">{{ title }}</div>
        @for (item of items.items; track $index) {
            <button
                class="section-item"
                [class.active]="item.id === items.activeItem"
                (click)="openSection(item.id)"
            >
                {{ item.name }}
            </button>
        }
    </div>
    <div class="slide-out-main">
        <ng-content></ng-content>
    </div>
</app-cerrix-slide-out>
